import { CheckCircle, Receipt, WarningCircle, ClipboardText } from "@phosphor-icons/react";

const META = {
    completed: { cls: "chip-gray", icon: ClipboardText, label: "Completed" },
    invoiced: { cls: "chip-navy", icon: Receipt, label: "Invoiced" },
    paid: { cls: "chip-green", icon: CheckCircle, label: "Paid" },
    overdue: { cls: "chip-orange", icon: WarningCircle, label: "Overdue" },
};

export function BillingStatusBadge({ status, className = "" }) {
    const meta = META[status];
    if (!meta) return null;
    const Icon = meta.icon;
    return (
        <span className={`chip ${meta.cls} whitespace-nowrap ${className}`} style={{ padding: "1px 6px", fontSize: "10px" }} data-testid={`billing-status-${status}`}>
            <Icon size={9} weight={status === "paid" ? "fill" : "bold"} /> {meta.label}
        </span>
    );
}
